// extracted by mini-css-extract-plugin
export var clickableWrapper = "_30-2";
export var placeholderIcon = "_30-3";
export var thumbnailCanvas = "_30-1";
export var thumbnailWrapper = "_30-0";